/**
 * Application entry point
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import {
    BrowserRouter,
} from 'react-router-dom'
import CssBaseline from '@mui/material/CssBaseline'
import {
    ThemeProvider,
} from '@mui/material/styles'
import App from './App'
import theme from './theme'
import {
    AuthProvider,
} from './contexts/AuthContext'
import {
    LanguageProvider,
} from './contexts/LanguageContext'
import './i18n'

// Call API health endpoint to keep it warm
fetch(import.meta.env.VITE_API_URL + '/health').catch(() => {
    // Ignore errors
})

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <BrowserRouter>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <LanguageProvider>
                    <AuthProvider>
                        <App />
                    </AuthProvider>
                </LanguageProvider>
            </ThemeProvider>
        </BrowserRouter>
    </React.StrictMode>
)
